'use strict';
module.exports = 9007199254740991;



//////////////////
// WEBPACK FOOTER
// ./~/max-safe-integer/index.js
// module id = 1658
// module chunks = 1